import React from 'react'

import IcoMoon from 'react-icomoon'

import tIcon from '../../types/icons'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const iconSet = require('../../selection.json')

// Taken from the react icomoon definitions to prevent linting errors
export interface IconProps extends React.HTMLAttributes<HTMLElement> {
  /**
   * The name of the icon
   */
  icon: tIcon

  /**
   * Set the size of the icon can be a numeric or an string like `14px`
   */
  iconSize?: string | number
}

const Icon: React.FC<IconProps> = ({ iconSize = 14, ...props }) => (
  <IcoMoon iconSet={iconSet} size={iconSize} {...props} />
)

export default Icon
